import SearchFilterController from './search-filter.controller';
import { SearchFilterProps } from './search-filter.model';

const SearchFilter: React.FC<SearchFilterProps> = (props) => {
  return <SearchFilterController {...props} />;
};

export default SearchFilter;
